import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '热门分类',
    links: [
      { label: '明星爆料', path: '/category/celebrity' },
      { label: '网红黑料', path: '/category/influencer' },
      { label: '社会热点', path: '/category/society' },
      { label: '综艺爆料', path: '/category/variety' },
    ],
  },
  {
    title: '快速导航',
    links: [
      { label: '首页', path: '/' },
      { label: '关于我们', path: '/about' },
      { label: '最新爆料', path: '/' },
      { label: '热门排行', path: '/' },
    ],
  },
  {
    title: '关于本站',
    links: [
      { label: '品牌介绍', path: '/about' },
      { label: '联系我们', path: '/about' },
      { label: '用户协议', path: '#' },
      { label: '隐私政策', path: '#' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-background-100">
      <div className="px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="bg-background-50 rounded-2xl px-6 md:px-10 py-10 md:py-12">
            <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">
              <div className="lg:w-1/4">
                <Link to="/" className="flex items-center gap-2.5 group cursor-pointer mb-4">
                  <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                    <i className="ri-leaf-fill text-xl text-background-50"></i>
                  </span>
                  <span className="text-xl font-heading font-bold text-foreground-950">
                    51黑料网
                  </span>
                </Link>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  全网热门黑料爆料与吃瓜事件汇总平台。每日实时更新，带你第一时间了解娱乐圈、网红圈最新动态与真相。
                </p>
                <div className="flex items-center gap-3 mt-5">
                  <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-100 text-foreground-600 hover:bg-primary-100 hover:text-primary-600 transition-colors cursor-pointer" aria-label="微博">
                    <i className="ri-weibo-line text-base"></i>
                  </a>
                  <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-100 text-foreground-600 hover:bg-primary-100 hover:text-primary-600 transition-colors cursor-pointer" aria-label="微信">
                    <i className="ri-wechat-line text-base"></i>
                  </a>
                </div>
              </div>

              <div className="flex-1 grid grid-cols-2 md:grid-cols-3 gap-8">
                {footerLinks.map((group) => (
                  <div key={group.title}>
                    <h4 className="text-xs font-semibold uppercase tracking-widest text-foreground-400 mb-4">
                      {group.title}
                    </h4>
                    <ul className="flex flex-col gap-3">
                      {group.links.map((link) => (
                        <li key={link.label}>
                          <Link
                            to={link.path}
                            className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors cursor-pointer"
                          >
                            {link.label}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
            </div>

            <div className="border-t border-background-200/70 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
              <p className="text-xs text-foreground-500">
                &copy; 2026 51黑料网 3kyzh.com. All rights reserved.
              </p>
              <div className="flex items-center gap-4 text-xs text-foreground-500">
                <a href="#" className="hover:text-foreground-700 transition-colors cursor-pointer">用户协议</a>
                <span className="text-foreground-300">|</span>
                <a href="#" className="hover:text-foreground-700 transition-colors cursor-pointer">隐私政策</a>
                <span className="text-foreground-300">|</span>
                <a href="#" className="hover:text-foreground-700 transition-colors cursor-pointer">免责声明</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
